var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video',{staticClass:"d-block video-top",attrs:{"width":"100%","src":_vm.files + (_vm.xsOnly && _vm.item.mobile ? _vm.item.mobile : _vm.item.desktop),"autoplay":"","muted":""},domProps:{"muted":true}})}
var staticRenderFns = []

export { render, staticRenderFns }